module.exports = __webpack_public_path__ + "img/Leste-Logo.22f98743.svg";